import { createContext, useContext } from "react";
import { chatDocuments, type ChatDocuments } from "./chatDocuments";

const GuestChatScope = createContext(false);

/** Mounted around the chat of a browser with no account (`/start`). */
export const GuestChatScopeProvider = GuestChatScope.Provider;

/** Whether the chat around this component runs for a browser with no account. */
export const useIsGuestChat = (): boolean => useContext(GuestChatScope);

/**
 * The documents of the chat this component sits in: the logged-in ones, or the
 * guest's twins under `GuestChatScopeProvider`. Content that opens in the global
 * `ModalProvider` renders outside that tree, so its opener passes the document down.
 */
const useChatDocuments = (): ChatDocuments => chatDocuments(useIsGuestChat());

export default useChatDocuments;
